import { BaseRemoteService } from '@ofqual/portal-core/core/dataAccess';
import { Model, Opts } from '@ofqual/portal-core/core/types';

export class RefDataService extends BaseRemoteService {
 private resource: string;

 constructor(baseUrl: string, resource: string) {
  super(baseUrl);
  this.resource = resource;
 }

 public async getAll(opts: Opts): Promise<Model[]> {
  const url = `${this.apiRoot}/${this.resource}`;
  const data = await super.getRequest<Model[]>(url, opts);
  return data
   .filter((x) => x.active)
   .sort((a, b) =>
    !!a.sortOrder && !!b.sortOrder
     ? a.sortOrder - b.sortOrder
     : a.value.localeCompare(b.value),
   )
   .map((x) => ({ id: x.id, label: x.value }));
 }
 public async get(id: string, opts: Opts): Promise<Model> {
  const url = `${this.apiRoot}/${this.resource}/${id}`;
  const item = await super.getRequest<Model>(url, opts);
  return {
   ...item,
   label: item.value,
  };
 }
}

export const refDataEndpoints = {
 lcmPolicyProjectCategory: 'LCMPolicyProjectCategory',
 lcmPolicySubCategory: 'LCMPolicyProjectSubCategory',
};
